export {}
declare global {
    interface Date {
        getDifferenceInMonths(date: Date): number;
        getDifferenceInYears(date: Date): number;
    }
}

Date.prototype.getDifferenceInMonths = function (date): number {
    let months: number;
    months = (date.getFullYear() - this.getFullYear()) * 12;
    months -= this.getMonth();
    months += date.getMonth();
    return months <= 0 ? 0 : months;
}

Date.prototype.getDifferenceInYears = function (date): number {
    return Math.abs(this.getFullYear() - date.getFullYear());
}
